/**
 * Google Ads conversion tracking helper.
 * gtag.js is loaded in index.html (via Google Analytics G-6SZX2KE2RG).
 * These helpers fire conversion events for key user actions.
 */

const CONVERSION_ID = "AW-17442134484";

const gtagEvent = (action, params = {}) => {
  if (typeof window !== "undefined" && window.gtag) {
    window.gtag("event", action, params);
  }
};

/**
 * Track a completed registration as a Google Ads conversion.
 * Call this AFTER the signup API returns success.
 */
export const trackGoogleAdsRegistration = () => {
  gtagEvent("conversion", {
    send_to: `${CONVERSION_ID}/6yVjCOu6n80cENSzh_1A`,
  });
};
